import React from "react";
import MDSpinner from "react-md-spinner";
import SimulationTime from "./SimulationTime";

class ReviewOrders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTable: "orderSheet",
      caseEndLoading: false,
    };

    this.changeTable = this.changeTable.bind(this);
  }

  changeTable(table) {
    this.setState({ selectedTable: table });
  }

  fetchGrading = async () => {
    this.setState({ caseEndLoading: true });
    await this.props.fetchGrading(
      this.props.caseData.ReviewLaterFlag,
      this.props.caseData.ID,
    );
    this.setState({ caseEndLoading: false });
  };

  renderCancelledLabel(order) {
    if (!order.CANCELLED) return null;

    return <span className="cancelled-label">CANCELLED</span>;
  }

  renderOrderSheetTable() {
    const orders = this.props.orderSheet.map((order, index) => (
      <tr
        key={index}
        onClick={this.props.reviewPopup.bind(this, "cancelOrder", order, index)}
      >
        <td>{order.NAME}</td>
        <td>{order.ROUTE}</td>
        <td>{order.FREQUENCY}</td>
        <td>
          <SimulationTime simulationTime={order.CurrentVirtualTime} />
        </td>
        <td>
          <SimulationTime simulationTime={order.ReportTime} />
        </td>
      </tr>
    ));

    return (
      <div className="order-review-table">
        <p className="order-review-table-header">Order Sheet</p>
        <table className="order-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Route</th>
              <th>Frequency</th>
              <th>Order Time</th>
              <th>Report Time</th>
            </tr>
          </thead>
          <tbody>{orders}</tbody>
        </table>
      </div>
    );
  }

  renderProgressNotesTable() {
    const orders = this.props.progressNotes.map((order, index) => (
      <tr
        key={`order-${index}`}
        onClick={() => this.props.reviewOrderPopup(order)}
      >
        <td>{order.NAME}</td>
        <td>
          <SimulationTime simulationTime={order.CurrentVirtualTime} />
        </td>
        <td>
          <SimulationTime simulationTime={order.ReportTime} />
        </td>
      </tr>
    ));

    const patientUpdates = this.props.patientUpdates.map((update, index) => (
      <tr
        key={`update-${index}`}
        onClick={this.props.reviewPopup.bind(this, "patientUpdate", update)}
      >
        <td>Patient Update</td>
        <td></td>
        <td>
          <SimulationTime simulationTime={update.CurrentVirtualTime} />
        </td>
      </tr>
    ));

    const physicals = this.props.completedPhysicals.map((physical, index) => (
      <tr
        key={`physical-${index}`}
        onClick={this.props.reviewPopup.bind(this, "physicalResults", index)}
      >
        <td>History and Physical</td>
        <td>
          <SimulationTime simulationTime={physical.timeOrdered} />
        </td>
        <td>
          <SimulationTime simulationTime={physical.timeReported} />
        </td>
      </tr>
    ));

    return (
      <div className="order-review-table">
        <table className="order-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Time Ordered</th>
              <th>Time Reported</th>
            </tr>
          </thead>
          <tbody>
            <tr onClick={this.props.reviewPopup.bind(this, "caseIntroduction")}>
              <td>Case Introduction</td>
              <td>
                <SimulationTime simulationTime={this.props.startTime} />
              </td>
              <td>
                <SimulationTime simulationTime={this.props.startTime} />
              </td>
            </tr>
            <tr onClick={this.props.reviewPopup.bind(this, "initialHistory")}>
              <td>Initial History</td>
              <td>
                <SimulationTime simulationTime={this.props.startTime} />
              </td>
              <td>
                <SimulationTime simulationTime={this.props.startTime} />
              </td>
            </tr>
            {physicals}
            {patientUpdates}
            {orders}
          </tbody>
        </table>
      </div>
    );
  }

  renderVitalSignsTable() {
    const orders = this.props.vitalSigns.map((order, index) => (
      <tr key={index} onClick={() => this.props.reviewOrderPopup(order)}>
        <td>{order.NAME}</td>
        <td>
          <SimulationTime simulationTime={order.CurrentVirtualTime} />
        </td>
        <td>
          {this.renderCancelledLabel(order)}
          <SimulationTime simulationTime={order.ReportTime} />
        </td>
      </tr>
    ));

    return (
      <div className="order-review-table">
        <table className="order-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Time Ordered</th>
              <th>Time Reported</th>
            </tr>
          </thead>
          <tbody>
            <tr onClick={this.props.reviewPopup.bind(this, "initialVitals")}>
              <td>Initial Vital Signs</td>
              <td>
                <SimulationTime simulationTime={this.props.startTime} />
              </td>
              <td>
                <SimulationTime simulationTime={this.props.startTime} />
              </td>
            </tr>
            {orders}
          </tbody>
        </table>
      </div>
    );
  }

  renderGenericTable(dataSource) {
    const orders = dataSource.map((order, index) => (
      <tr key={index} onClick={() => this.props.reviewOrderPopup(order)}>
        <td>{order.NAME}</td>
        <td>
          <SimulationTime simulationTime={order.CurrentVirtualTime} />
        </td>
        <td>
          {this.renderCancelledLabel(order)}
          <SimulationTime simulationTime={order.ReportTime} />
        </td>
      </tr>
    ));

    return (
      <div className="order-review-table">
        <table className="order-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Time Ordered</th>
              <th>Time Reported</th>
            </tr>
          </thead>
          <tbody>{orders}</tbody>
        </table>
      </div>
    );
  }

  renderTable() {
    switch (this.state.selectedTable) {
      case "orderSheet":
        return this.renderOrderSheetTable();
      case "progressNotes":
        return this.renderProgressNotesTable();
      case "vitalSigns":
        return this.renderVitalSignsTable();
      case "labReports":
        return this.renderGenericTable(this.props.labReports);
      case "imaging":
        return this.renderGenericTable(this.props.imaging);
      case "otherTests":
        return this.renderGenericTable(this.props.otherTests);
      case "treatmentRecord":
        return this.renderGenericTable(this.props.treatmentRecord);
      default:
        return null;
    }
  }

  renderButtons() {
    let orderButtonStyle;
    if (this.state.selectedTable !== "orderSheet") {
      orderButtonStyle = "fade";
      return <></>;
    }

    if (this.props.endCase && this.state.caseEndLoading) {
      return (
        <div className="options-footer-loading-container">
          <MDSpinner size={25} singleColor={this.props.primaryColor} />
        </div>
      );
    }

    if (this.props.endCase) {
      return (
        <div className="review-orders-footer">
          <input
            className="simulation-button-soft button-gap"
            type="button"
            value="Write New Orders"
            onClick={this.props.setPopup.bind(this, "orders")}
          />
          <input
            className="simulation-button-soft"
            type="button"
            value="Exit Case"
            onClick={this.fetchGrading}
          />
        </div>
      );
    }

    return (
      <div className="review-orders-footer">
        <input
          className={"simulation-button-soft " + orderButtonStyle}
          type="button"
          value="Order"
          onClick={this.props.setPopup.bind(this, "orders")}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="review-orders">
        <div className="review-orders-content">
          <div className="review-orders-chart-tabs">
            <div className="review-orders-chart-tabs-group">
              <div
                className={
                  "review-orders-chart-tab " +
                  ("orderSheet" === this.state.selectedTable)
                }
                onClick={this.changeTable.bind(this, "orderSheet")}
              >
                Order Sheet
              </div>
              <div
                className={
                  "review-orders-chart-tab " +
                  ("progressNotes" === this.state.selectedTable)
                }
                onClick={this.changeTable.bind(this, "progressNotes")}
              >
                Progress Notes
              </div>
              <div
                className={
                  "review-orders-chart-tab " +
                  ("vitalSigns" === this.state.selectedTable)
                }
                onClick={this.changeTable.bind(this, "vitalSigns")}
              >
                Vital Signs
              </div>
              <div
                className={
                  "review-orders-chart-tab " +
                  ("labReports" === this.state.selectedTable)
                }
                onClick={this.changeTable.bind(this, "labReports")}
              >
                Lab Reports
              </div>
            </div>
            <div className="review-orders-chart-tabs-group">
              <div
                className={
                  "review-orders-chart-tab " +
                  ("imaging" === this.state.selectedTable)
                }
                onClick={this.changeTable.bind(this, "imaging")}
              >
                Imaging
              </div>
              <div
                className={
                  "review-orders-chart-tab " +
                  ("otherTests" === this.state.selectedTable)
                }
                onClick={this.changeTable.bind(this, "otherTests")}
              >
                Other Tests
              </div>
              <div
                className={
                  "review-orders-chart-tab " +
                  ("treatmentRecord" === this.state.selectedTable)
                }
                onClick={this.changeTable.bind(this, "treatmentRecord")}
              >
                Treatment Record
              </div>
            </div>
          </div>
          <div className="review-orders-table-wrapper">
            {this.renderTable()}
            {this.renderButtons()}
          </div>
        </div>
      </div>
    );
  }
}

export default ReviewOrders;
